import { Box, Grid, Typography } from "@mui/material";
import { FormSection } from "components/FormControls/FormSection";
import { NumberFormatInput } from "components/FormControls/NumberFormatInput";
import { OLSwitch } from "components/FormControls/Toggle";
import { useMessage } from "hooks/intl";
import { useState } from "react";
import { useStyles } from "../SimulateCampaign.styles";

interface Props {
  fieldNamePrefix: "customer" | "referrer";
  clearPointsBalanceFields: () => void;
  isPointsBalanceAttached?: boolean;
}

export const PointsBalance = ({
  fieldNamePrefix,
  isPointsBalanceAttached,
  clearPointsBalanceFields,
}: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const [isOpen, setIsOpen] = useState(isPointsBalanceAttached);

  return (
    <FormSection>
      <Box className={classes.sectionHeaderContainer}>
        <Typography className={classes.title}>
          {message({ id: "pointsBalance" })}
        </Typography>
        <OLSwitch
          checked={isOpen}
          onChange={() => {
            if (isOpen) {
              clearPointsBalanceFields();
            }
            setIsOpen(!isOpen);
          }}
          data-test-id="points-balance-switch"
        />
      </Box>
      {isOpen ? (
        <Grid container spacing={12} mt={0}>
          <Grid item xs={6}>
            <NumberFormatInput
              allowDecimals
              className={classes.input}
              label={message({ id: "activePoints" })}
              name={`${fieldNamePrefix}.activePoints`}
              data-test-id="active-points"
            />
          </Grid>
          <Grid item xs={6}>
            <NumberFormatInput
              allowDecimals
              className={classes.input}
              label={message({ id: "usedPoints" })}
              name={`${fieldNamePrefix}.spentPoints`}
              data-test-id="used-points"
            />
          </Grid>
          <Grid item xs={6}>
            <NumberFormatInput
              allowDecimals
              className={classes.input}
              label={message({ id: "totalEarnedPoints" })}
              name={`${fieldNamePrefix}.earnedPoints`}
              data-test-id="total-earned-points"
            />
          </Grid>
          <Grid item xs={6}>
            <NumberFormatInput
              allowDecimals
              className={classes.input}
              label={message({ id: "lockedPoints" })}
              name={`${fieldNamePrefix}.lockedPoints`}
              data-test-id="locked-points"
            />
          </Grid>
          <Grid item xs={6}>
            <NumberFormatInput
              allowDecimals
              className={classes.input}
              label={message({ id: "blockedPoints" })}
              name={`${fieldNamePrefix}.blockedPoints`}
              data-test-id="blocked-points"
            />
          </Grid>
          <Grid item xs={6}>
            <NumberFormatInput
              allowDecimals
              className={classes.input}
              label={message({ id: "expiredPoints" })}
              name={`${fieldNamePrefix}.expiredPoints`}
              data-test-id="expired-points"
            />
          </Grid>
        </Grid>
      ) : null}
    </FormSection>
  );
};
